/**
 * assets/collection-hub.js
 * Gedrag van sections/collection-hub.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

  (function () {
    if (window.__hubHelpTracked) { return; }
    window.__hubHelpTracked = true;
    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-hub-help]');
      if (!el) { return; }
      var payload = {
        hub: el.getAttribute('data-hub-help') || '',
        help_type: el.getAttribute('data-help-type') || '',
        primary: el.getAttribute('data-help-primary') === 'true'
      };
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'hub_help_click', payload);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'hub_help_click',
          hub: payload.hub,
          help_type: payload.help_type,
          primary: payload.primary
        });
      }
    }, { passive: true });
  })();

(function () {
  var link = document.querySelector('a[data-hub-readmore]');
  if (!link) { return; }
  link.addEventListener('click', function (event) {
    var target = document.getElementById('collection-description');
    if (!target) { return; }
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#collection-description');
    }
  });
})();
